import { Queue, Resposta } from 'models';
import { Creators as queueCreators } from './queue';
import { Creators as PerguntasCreators } from './perguntas';
import { Creators as RespostasCreators } from './respostas';
import Helpers from 'shared/helpers';

export const Types = {
  UPDATE: 'dadosiniciais/UPDATE',
  UPDATE_SUCCESS: 'dadosiniciais/UPDATE_SUCCESS',
  UPDATE_FAILED: 'dadosiniciais/UPDATE_FAILED',
};

const initialState = {
  loading: false,
  error: null,
};

export default function dadosIniciaisReducer(state = initialState, action) {
  switch (action.type) {
    case Types.UPDATE:
      return { ...state, loading: true };
    case Types.UPDATE_SUCCESS:
      return { ...state, loading: false };
    case Types.UPDATE_FAILED:
      return { ...state, loading: false, error: action.payload.error };
    default:
      return state;
  }
}

export const Creators = {
  update: (id, details) => async dispatch => {
    try {
      dispatch({ type: Types.UPDATE });
      const ids = [];
      Helpers.asyncForEach(
        Object.entries(details.pergunta),
        async (resposta, index) => {
          const resp = new Resposta({
            pergunta_id: Number(resposta[0]),
            pem_id: Number(id),
            resposta: resposta[1],
          });
          await resp.save();
          ids.push(resp._id);
          if (index === Object.entries(details.pergunta).length - 1) {
            const queue = new Queue({
              url: `dados/${id}`,
              table: 'respostas',
              localId: ids,
              requestBody: details,
            });
            await queue.save();
          }
        },
      );
      dispatch({ type: Types.UPDATE_SUCCESS });
      setTimeout(() => {
        dispatch(queueCreators.getQueue());
        setTimeout(() => {
          dispatch(
            PerguntasCreators.getPerguntas(pergunta => pergunta.fase.id === 1),
          );
          dispatch(
            RespostasCreators.getRespostas(
              resposta => String(resposta.pem_id) === String(id),
            ),
          );
        }, 1000);
      }, 200);
    } catch (woof) {
      console.error(woof.message);
      dispatch({
        type: Types.UPDATE_FAILED,
        payload: { error: 'Serviço indisponível' },
      });
    }
  },
};
